import { PluginObject } from 'vue'
import { IDDErrorHandler } from './dd-error-handler.types'
import DdErrorHandler from './dd-error-handler'
import router from '@/services/router/router'
import store from '@/services/store/store'

export default {
  install(Vue, options) {
    Vue.prototype.$error = new DdErrorHandler(router, store)
  },
} as PluginObject<IDDErrorHandler>
